import { useContext, useState } from "react";
import { toast } from "react-toastify";
import Button from "../../components/Button/Button";
import api from "../../js/api";
import { UserContext } from "../../js/UserContext";
import './Git.scss';

async function pullRepo(repo, setLoading) {
    setLoading(repo);
    const toastId = toast.loading(`> git pull ${repo}...`);
    const res = await api.post(`/git/${repo}/pull`);
    if (res.error) {
        toast.update(toastId, {
            render: `> error: ${res.message || 'pull failed'}`,
            type: 'error',
            isLoading: false,
            autoClose: 4000,
        });
    } else {
        toast.update(toastId, {
            render: `> ${repo}: already up to date.`,
            type: 'success',
            isLoading: false,
            autoClose: 3000,
        });
    }
    setLoading(null);
}

export default function Git() {
    const { user } = useContext(UserContext);
    const [loading, setLoading] = useState(null);

    return (
        <div id='git'>
            <div className='centered-container'>
                <h2> Git Repositories </h2>
                <br />
                {(user?.login === 'ang' || user.roles.includes('root')) && (
                    <Button
                        text={loading === 'ang' ? '> pulling...' : 'Ang'}
                        onClick={() => !loading && pullRepo('ang', setLoading)}
                        class_={`git-button${loading === 'ang' ? ' loading' : ''}`}
                    />
                )}
                {(user?.login === 'mariu' || user.roles.includes('root')) && (
                    <Button
                        text={loading === 'mariu' ? '> pulling...' : 'Mariu'}
                        onClick={() => !loading && pullRepo('mariu', setLoading)}
                        class_={`git-button${loading === 'mariu' ? ' loading' : ''}`}
                    />
                )}
            </div>
        </div>
    );
}